<template>
    <div>
        <div v-show="isDataTableLoading === false">
            <template v-if="paymentSlips">
                <div class="page-top mb-1 mb-3 align-left clearfix">
                    <h1> Payment Slips</h1>
                </div>
                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="new-tab" data-toggle="tab" href="#new" role="tab"
                                aria-controls="new" aria-selected="true" @click="reloadList('PENDING')">New
                                ({{new_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab"
                                aria-controls="inprocess" aria-selected="false" @click="reloadList('APPROVED')">Approved
                                ({{approved_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="processed-tab" data-toggle="tab" href="#processed" role="tab"
                                aria-controls="processed" aria-selected="false" @click="reloadList('REJECTED')">Rejected
                                ({{rejected_count}})</a>
                        </li>
                    </ul>

                    <!-- <router-link to="/topupBulkUpload"  class="btn btn-primary float-right mr-1" v-if="uploadTopupButton == true"> New Batch </router-link> -->
                </div>
                <div class="modal fade" id="getReason" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body login-mobilizer text-left p-4">
                                    <div class="moblizer-account-detail">
                                        <div class="alert alert-danger pl-2" v-if="errorMessage!==''">{{errorMessage}}</div>
                                        <div v-if="form.status=='APPROVED'">
                                            <label class="label block-label"> Transaction No </label>
                                            <div class="form-group mb-2">
                                                <textarea v-model="form.transaction_no" class="form-control"  ></textarea>
                                            </div>
                                        </div>
                                        <label class="label block-label"> Reason </label>
                                        <div class="form-group mb-2">
                                            <textarea v-model="form.reason" class="form-control"  ></textarea>
                                        </div>
                                        <div class="row normal-ib-space mt-3">
                                            <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" @click="close()"> Cancel </button> </div>
                                            <div class="col"> <button  class="btn btn-primary active" id="submit" @click="submitForm()"> Submit </button> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="dt-new" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Company</th>
                                    <th>Depositer</th>
                                    <th>Bank</th>
                                    <th>Virtual Account No</th>
                                    <th>Deposit Date</th>
                                    <th>Via</th>
                                    <th>Amount </th>
                                    <th>Deposit Slip </th>
                                    <th>Reason </th>
                                    <th>DateTime </th>
                                    <!-- <th>Action</th> -->
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="paymentSlips == null">
                <preLoader />
            </template>
            <template v-if="paymentSlips == false">
                <notAllowed></notAllowed>
            </template>
        </div>
        <preLoader v-show="isDataTableLoading === true"></preLoader>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form:new Form({
                    transaction_no:'',
                    reason:'',
                    id:'',
                    status:''
                }),
                isDataTableLoading:true,
                paymentSlips:false,
                rejected_count:0,
                approved_count:0,
                new_count:0,
                s3BaseUrl:'',
                datatable:false,
                errorMessage:'',
                fristload:true,
            };
        },
        mounted() {
           let  self = this;

            this.$Progress.start();
            this.can('view_payment_slip').then(result => {
                this.paymentSlips = result.view_payment_slip;
                if(this.paymentSlips){
                      self.getCounts();
                     setTimeout(function(){
                       self.datatableF();
                     },300)
                     $(document).on('click',(event)=>{
                         if (!$(event.target).closest('.custom-select , #submit , textarea').length ) {
                                   self.close();
                          } 
                     })
                }
            });
           
        },
        methods: {
            getCounts(){
                let self=this;
              axios.get('api/getPaymentSlipsCount')
              .then(function(res){
                  console.log(res);
                   self.rejected_count = res.data.rejected_count;
                   self.approved_count = res.data.approved_count;
                   self.new_count      = res.data.new_count;
                   self.s3BaseUrl      = res.data.s3BaseUrl;
              })
            },
              datatableF(){
                  self =this;
                this.datatable = $('#dt-new').DataTable({
                     processing: true,
                    serverSide: true,
                    responsive: true,
                    ordering: false,
                    ajax: {
                        "url": "api/PaymentSlipList/PENDING",
                          method: "get"
                    },
                    columns: [
                          {data:'company'},
                          {data:'name'},
                          {data:'bank'},
                          {data:'walletID'},
                          {data:'deposit_date'},
                          {data:'via'},
                          {data:'amount' , render: $.fn.dataTable.render.number(',', '.', 0, '')},
                           {render: function(data,type,full,row){
                           return `<a href="${self.s3BaseUrl+full['image']}" target="_blank">Preview</a>`
                          }},
                          {data:'comment'},
                          {data:'PaymentSlipDateTime'},
                          // {render: function(data,type,full,row){
                          //  return `<select class="form-control custom-select" id="statusOnchange${full['id']}" onchange="VueComponents.PaymentSlipsShowComponent.methods.changeStatus(${full['id']})">\
                          //          <option value="PENDING">Pending</option>\
                          //          <option value="REJECTED">Rejected</option>\
                          //          <option value="APPROVED">Approved</option>\
                          //          </select>`
                          // }},
                            ],
                            "drawCallback": function(settings) {
                                if(self.fristload){
                                    self.fristload=false;
                                   var columnReason = self.datatable.column(8);
                                     columnReason.visible(false);
                                    self.isDataTableLoading = false;
                                }

                            }
                });
            },
            close(){
                if(self.form.id != 'undefine' || self.form.id != ''){
                  $(`#statusOnchange${self.form.id}`).val('PENDING');
                }
            },
            changeStatus(id){
                // var form ={};
                console.log(self.form);
                self.errorMessage = '';
                self.form.id=id;
                self.form.status=$(`#statusOnchange${id}`).val();
                $('#getReason').modal('show');      
            },
            submitForm(reason=true){
              let that = this;
                self.disableButton('submit','Submitting…',true);
                if(self.form.status =='APPROVED' && self.form.transaction_no =='' && reason){
                     if(self.form.reason =='' && reason){
                        self.errorMessage='Please provide Reason and Transaction No';
                        self.disableButton('submit','Submit',false);
                        return false;
                    } else {
                        self.errorMessage='Please provide Transaction No';
                        self.disableButton('submit','Submit',false);
                        return false;
                    }
                }
                if(self.form.reason =='' && reason){
                    self.errorMessage='Please provide reason';
                    self.disableButton('submit','Submit',false);
                    return false;
                }
                $(`#statusOnchange${self.form.id}`).prop( "disabled", true );
                self.form.post('api/changePaymentSlipStatus')
                .then(function(res){
                        self.form.id='';
                        self.form.reason   = '';
                        self.errorMessage = '';
                    $('#getReason').modal('hide');      
                    self.showAlertBox('success','Action performed successfully!');
                    self.disableButton('submit','Submit',false);
                    that.$router.go(0);
                })
                .catch(error=>{
                $(`#statusOnchange${self.form.id}`).prop( "disabled", false );
                    self.disableButton('submit','Submit',false);
                    this.showAlertBox('error','There seems to be a problem please try again later');
                })
            },
            reloadList(tabClicked){
                this.status=tabClicked;
                this.datatable.ajax.url("api/PaymentSlipList/"+tabClicked).load();
                      let self=this;
                    var columnAction = self.datatable.column(10);
                    var columnReason = self.datatable.column(8);
                               if(this.status=='PENDING'){
                                  columnAction.visible( true );
                               }else{ console.log('ss');
                                  columnAction.visible( false );
                               }
                               if(this.status=='REJECTED' || this.status=='APPROVED'){
                                  columnReason.visible( true );
                               }else{
                                  columnReason.visible( false );
                               }
// this.datatable.ajax.reload();
            }
        },
    }
</script>
